let globalToastFn = null

export function registerToast(fn) {
  globalToastFn = fn
}

export function showToast(message, options = {}) {
  if (typeof globalToastFn === 'function') {
    globalToastFn(message, options)
  }
}

/**
 * Extrai as mensagens de erro de uma resposta da API.
 * Pura (sem DOM/toast) para ser testável isoladamente.
 *
 * Ordem: objeto `errors` do backend (achatado em lista) → `detail` → fallback genérico.
 */
export function extractApiErrorMessages(error) {
  const data = error?.response?.data

  const errors = data?.errors
  if (errors && typeof errors === 'object') {
    const messages = Object.values(errors)
      .flat()
      .filter(message => typeof message === 'string' && message)
    if (messages.length) return messages
  }

  if (typeof data?.detail === 'string' && data.detail) return [data.detail]

  return ['Erro desconhecido']
}

/**
 * Exibe um toast de erro a partir de um erro de API (sucessor do antigo
 * composable useApiError, que disparava Swal).
 */
export function showApiError(error, { title } = {}) {
  showToast(extractApiErrorMessages(error).join(' · '), {
    variant: 'error',
    ...(title ? { title } : {}),
  })
}
